/**
 * i18n configuration — Phase 6a.6 per spec §14.1.
 *
 * react-i18next + browser language detector. Persists user choice in
 * localStorage["ifrs16:lang"] (project-wide `ifrs16:` namespace). Falls back
 * to navigator.language → tr as the ultimate default.
 *
 * Imported once from main.tsx BEFORE <App /> renders so the i18n instance
 * is initialized before any component calls useTranslation().
 */

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "@/locales/en.json";
import tr from "@/locales/tr.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: tr },
      en: { translation: en },
    },
    fallbackLng: "tr",
    supportedLngs: ["tr", "en"],
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "ifrs16:lang",
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
    returnNull: false,
  });

export default i18n;
